import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BeneficiaryListFilter } from 'projects/merchant-portal/src/app/models/disbursement/beneficiary-list/beneficiary-list.interface';
import { Subject, debounceTime, skip, takeUntil } from 'rxjs';
import { BeneficiaryListFactoryService } from './factory/beneficiary-list-store-factory';

@Component({
  selector: 'app-beneficiary-list',
  templateUrl: './beneficiary-list.component.html',
  styleUrls: ['./beneficiary-list.component.scss'],
  standalone: false,
})
export class BeneficiaryListComponent implements OnInit, OnDestroy {
  datas: BeneficiaryListFactoryService['currentBeneficiaryList$'];
  totalRecord = this.beneficiaryListFactoryService.currentBeneficiaryListPagination$;
  status = [];
  types = [];
  dateFilter: Date[] = [];
  createdDate: any;
  selectedType = '';
  selectedStatus = '';
  ngUnSubcribe = new Subject<boolean>();
  filter: Partial<BeneficiaryListFilter> = {};
  private searchSubject = new Subject<void>();

  constructor(
    private beneficiaryListFactoryService: BeneficiaryListFactoryService,
    private activatedRoute: ActivatedRoute
  ) {
    this.beneficiaryListFactoryService.currentBeneficiaryListFilter$
      .pipe(takeUntil(this.ngUnSubcribe))
      .subscribe(value => {
        if (value.startCreatedAt && value.endCreatedAt) {
          this.dateFilter = [new Date(value.startCreatedAt), new Date(value.endCreatedAt)];
        }
        this.filter.beneficiaryAccountNo = value.beneficiaryAccountNo;
        this.filter.beneficiaryAccountName = value.beneficiaryAccountName;
        this.filter.page = value.page;
      });
    this.datas = this.beneficiaryListFactoryService.currentBeneficiaryList$;
    // Subscribe early so share() is active before ngOnInit triggers loadTrigger$
    this.datas.pipe(takeUntil(this.ngUnSubcribe)).subscribe();
  }

  ngOnInit(): void {
    // Load initial data using route snapshot (correct params, not stale)
    const params = this.activatedRoute.snapshot.queryParams;
    this.filter.page = params['page'] || 1;
    this.filter.beneficiaryAccountName = params['beneficiaryAccountName'];
    this.filter.beneficiaryAccountNo = params['beneficiaryAccountNo'];
    this.beneficiaryListFactoryService.requestBeneficiaryList(this.filter);

    // Debounced search for text inputs — resets to page 1 on search
    this.searchSubject
      .pipe(debounceTime(300), skip(1), takeUntil(this.ngUnSubcribe))
      .subscribe(() => {
        this.beneficiaryListFactoryService.requestBeneficiaryList({
          ...this.filter,
          page: 1,
        });
      });
  }

  ngOnDestroy(): void {
    this.ngUnSubcribe.next(true);
    this.ngUnSubcribe.complete();
  }

  onSearchInputChange(): void {
    this.searchSubject.next();
  }

  onFilterChange() {
    this.beneficiaryListFactoryService.requestBeneficiaryList({
      ...this.filter,
      page: 0,
    });
  }

  onPageChange(event: number) {
    if (event !== undefined) {
      this.beneficiaryListFactoryService.requestBeneficiaryList({
        ...this.filter,
        page: event + 1,
      });
    }
  }

  onFilterDateChange(event: Date[]) {
    if (event[1]) {
      this.filter.startCreatedAt = event[0];
      this.filter.endCreatedAt = event[1];
    }
  }

  clearField(fieldName: keyof BeneficiaryListFilter): void {
    this.filter[fieldName] = undefined;
    if (fieldName == 'startCreatedAt') {
      this.dateFilter = [];
      this.filter['endCreatedAt'] = undefined;
    }
  }
}
